import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import HtmlEditor from "../../../../components/UI/HtmlEditorInput/HtmlEditor";

const FormRelCircunstanciado = ({ formik, atividade }) => (
  <>
    {atividade !== "AI1" && (
      <Row>
        <Form.Group as={Col} sm={12} md={12}>
          <Form.Label>
            <strong>* RELATÓRIO CIRCUNSTANCIADO</strong>
          </Form.Label>
        </Form.Group>
      </Row>
    )}
    <br />
    <Row>
      <Form.Group as={Col} sm={12} md={12}>
        <Form.Label>
          <strong>Informações Preliminares</strong>
        </Form.Label>
        <HtmlEditor formik={formik} field="txPreliminares" />
      </Form.Group>
    </Row>
    <br />
    <Row>
      <Form.Group as={Col} sm={12} md={12}>
        <Form.Label>
          <strong>Procedimentos</strong>
        </Form.Label>
        <HtmlEditor formik={formik} field="txProcedimentos" />
      </Form.Group>
    </Row>
    <br />
    <Row>
      <Form.Group as={Col} sm={12} md={12}>
        <Form.Label>
          <strong>Constatações</strong>
        </Form.Label>
        <HtmlEditor formik={formik} field="txConstatacoes" />
      </Form.Group>
    </Row>
    <br />
    <Row>
      <Form.Group as={Col} sm={12} md={12}>
        <Form.Label>
          <strong>Ocorrências</strong>
        </Form.Label>
        <HtmlEditor formik={formik} field="txOcorrencias" />
      </Form.Group>
    </Row>
    <br />
    <Row>
      <Form.Group as={Col} sm={12} md={12}>
        <Form.Label>
          <strong>Resultado da Ação</strong>
        </Form.Label>
        <HtmlEditor formik={formik} field="txResultado" />
      </Form.Group>
    </Row>
  </>
);

export default FormRelCircunstanciado;
